import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { UrlService } from '../url/url.service';
import { Version } from '../../objects/version';
import { Message } from '../../objects/message';

@Injectable({
    providedIn: 'root'
})

export class MessagesService {

    constructor(public urlSrv: UrlService, public http: HttpClient){}

    // find(version: Version, urlPrefix: string = "") {
    //     return this.http.get(this.urlSrv.build(urlPrefix + "/versions/" + version.id+"/messages"));
    // }
    /**
     * 
     * @param message 
     * @param prefixUrl 
     * @param context should be dafault if the call use the url on the Appliication used, but if we want to call
     * /web/share on /app screen we neet to avoid use of url service. 
     * This is a FRONT context only associated with where service is called. not a Message object property
     * @returns subscriber to listen the response of delete call
     */
    remove(message: Message, prefixUrl: string = "",context: string = "" ) {
        return this.http.delete(this.getContextUrl(prefixUrl,context) +"/messages/"+message.id);
    }

    protected getContextUrl(prefix: string, context:string){
        return (context != "" && context != 'message-default') ? prefix : this.urlSrv.build(prefix);
    }

}
